export const GLOBAL_USERS_TABLE_CONST = {
    tNamespace: "project",
    tPaths: {
        noUsers: "user-management.no-users"
    }
}
